export const categories = [
  'All',
  'Men',
  'Women',
  'Beauty',
];

export const products = [
  {
    id: 1,
    name: 'Classic Denim Jacket',
    category: 'Men',
    price: 559,
    rating: 4.3,
    badge: 'Trending',
    image: '/Assets/Men/1.jpg',
    description:
      'A versatile denim jacket designed for everyday casual looks with durable stitching and a comfortable fit.',
  },
  {
    id: 2,
    name: 'Urban Casual Shirt',
    category: 'Men',
    price: 459,
    rating: 4.1,
    badge: 'Best Seller',
    image: '/Assets/Men/2.jpg',
    description:
      'Lightweight casual shirt with a clean silhouette that works well for office-casual and weekend wear.',
  },
  {
    id: 3,
    name: 'Slim Fit Polo Tee',
    category: 'Men',
    price: 659,
    rating: 4.4,
    badge: 'New',
    image: '/Assets/Men/3.jpg',
    description:
      'Soft polo tee with breathable fabric and a polished look for smart casual outfits.',
  },
  {
    id: 4,
    name: 'Comfort Street Hoodie',
    category: 'Men',
    price: 759,
    rating: 4.5,
    badge: 'Popular',
    image: '/Assets/Men/4.jpg',
    description:
      'Warm hoodie crafted for comfort, layering, and everyday streetwear styling.',
  },
  {
    id: 5,
    name: 'Minimal Checked Shirt',
    category: 'Men',
    price: 859,
    rating: 4.2,
    badge: 'Premium',
    image: '/Assets/Men/5.jpg',
    description:
      'A premium checked shirt with subtle patterns and a modern tailored cut.',
  },
  {
    id: 6,
    name: 'Weekend Layered Jacket',
    category: 'Men',
    price: 959,
    rating: 4.6,
    badge: 'Top Rated',
    image: '/Assets/Men/6.jpg',
    description:
      'A structured outer layer built for style, comfort, and easy seasonal pairing.',
  },
  {
    id: 7,
    name: 'Elegant Floral Dress',
    category: 'Women',
    price: 1559,
    rating: 4.6,
    badge: 'Top Pick',
    image: '/Assets/Woman/1.jpg',
    description:
      'Flowy floral dress designed for comfort and elegance across casual and festive occasions.',
  },
  {
    id: 8,
    name: 'Chic Summer Outfit',
    category: 'Women',
    price: 1459,
    rating: 4.2,
    badge: 'New',
    image: '/Assets/Woman/2.jpg',
    description:
      'A clean and modern summer outfit that balances fashion and day-long comfort.',
  },
  {
    id: 9,
    name: 'Classic Ethnic Wear',
    category: 'Women',
    price: 1659,
    rating: 4.5,
    badge: 'Trending',
    image: '/Assets/Woman/3.jpg',
    description:
      'Elegant ethnic-inspired wear that blends traditional detail with a contemporary cut.',
  },
  {
    id: 10,
    name: 'Pastel Party Dress',
    category: 'Women',
    price: 1759,
    rating: 4.4,
    badge: 'Popular',
    image: '/Assets/Woman/4.jpg',
    description:
      'Party-ready pastel dress with a flattering shape and standout detail work.',
  },
  {
    id: 11,
    name: 'Modern Fusion Set',
    category: 'Women',
    price: 1859,
    rating: 4.3,
    badge: 'Premium',
    image: '/Assets/Woman/5.jpg',
    description:
      'A fashion-forward fusion set that offers a sharp profile and polished finish.',
  },
  {
    id: 12,
    name: 'Designer Statement Dress',
    category: 'Women',
    price: 1959,
    rating: 4.7,
    badge: 'Best Seller',
    image: '/Assets/Woman/6.jpg',
    description:
      'A premium statement dress built for standout occasions and elevated styling.',
  },
  {
    id: 13,
    name: 'Hydrating Face Serum',
    category: 'Beauty',
    price: 1059,
    rating: 4.5,
    badge: 'Skin Care',
    image: '/Assets/Beauty/1.jpg',
    description:
      'A lightweight face serum formulated to refresh, hydrate, and smooth daily skincare routines.',
  },
  {
    id: 14,
    name: 'Glow Finish Compact',
    category: 'Beauty',
    price: 1159,
    rating: 4.1,
    badge: 'Makeup',
    image: '/Assets/Beauty/2.jpg',
    description:
      'Compact powder with a natural finish for touch-ups and smooth coverage.',
  },
  {
    id: 15,
    name: 'Everyday Beauty Kit',
    category: 'Beauty',
    price: 959,
    rating: 4.4,
    badge: 'Combo',
    image: '/Assets/Beauty/3.jpg',
    description:
      'An everyday beauty combo built for quick routines and reliable essentials.',
  },
  {
    id: 16,
    name: 'Matte Lip Collection',
    category: 'Beauty',
    price: 859,
    rating: 4.0,
    badge: 'Popular',
    image: '/Assets/Beauty/4.jpg',
    description:
      'A curated lip collection offering bold matte shades for day and evening looks.',
  },
  {
    id: 17,
    name: 'Nourishing Hair Care Set',
    category: 'Beauty',
    price: 759,
    rating: 4.2,
    badge: 'Value Pack',
    image: '/Assets/Beauty/5.jpg',
    description:
      'A practical hair care set focused on nourishment, shine, and manageable styling.',
  },
  {
    id: 18,
    name: 'Luxury Fragrance Mist',
    category: 'Beauty',
    price: 959,
    rating: 4.6,
    badge: 'Premium',
    image: '/Assets/Beauty/6.jpg',
    description:
      'A long-lasting fragrance mist with a refined scent profile for daily wear.',
  },
];
